
window.theme.block('grid-cards', el => {
    const sliderElement = el.querySelector('.js-slider-cards');

    if (sliderElement) {
        new window.theme.packages.swiper(sliderElement, {
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 600,
            loop: false,
            navigation: {
                prevEl: el.querySelector('.js-prev'),
                nextEl: el.querySelector('.js-next')
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                },
                1280: {
                    slidesPerView: 4,
                },
            }
        });
    }
});
